module.exports = __webpack_public_path__ + "images/emoji/blue_book.6f5c747d2d5b35472c00.png";